// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ml20 {\n    margin-left: 20px;\n}\n\n.mr20 {\n    margin-right: 20px;\n}\n\n.mb20 {\n    margin-bottom: 20px;\n}\n\n.mt20 {\n    margin-top: 20px;\n}\n\n.ml10 {\n    margin-left: 10px;\n}\n\n.mr10 {\n    margin-right: 10px;\n}\n\n.mb10 {\n    margin-bottom: 10px;\n}\n\n.mt10 {\n    margin-top: 10px;\n}\n\n.ml5 {\n    margin-left: 5px;\n}\n\n.mr5 {\n    margin-right: 5px;\n}\n\n.mb5 {\n    margin-bottom: 5px;\n}\n\n.mt5 {\n    margin-top: 5px;\n}", ""]);
// Exports
module.exports = exports;
